import $ from '@rover/globals/jquery';
import _ from '@rover/globals/underscore';
import Rover from '@rover/globals/Rover';

import MobileSupportedModalView from './mobile_supported_modal_view';

export default MobileSupportedModalView.extend({
  events: {
    'click .js-modal-close': 'onClose',
    'click .js-apply-search-filters-button': 'onSubmit',
  },

  initialize(options) {
    MobileSupportedModalView.prototype.initialize.call(this, options);
    this.$modal.on('show.bs.modal', _.bind(this.loadContent, this));

    this.model.on('change:service_type', _.bind(this.onServiceTypeChange, this));
  },

  loadContent() {
    if (this.contentLoaded) {
      return;
    }

    this.onContentLoaded();
  },

  onContentLoaded() {
    this.contentLoaded = true;
    MobileSupportedModalView.prototype.onContentLoaded.call(this);
  },

  onServiceTypeChange(bbObj) {
    const stSlug = bbObj.changed.service_type;
    const stName = Rover.serviceTypesJson.find(st => st.slug === stSlug).name;
    $('.js-service-type-name').text(stName);
  },

  onReset() {
    this.model.reset();
  },

  onClose() {
    this.model.reset();
    this.hideModal();
  },

  onSubmit() {
    this.model.send();
    this.hideModal();
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/mobile_search_filters_modal_view.js